/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ServiceCspUnGated } from './serviceCspUnGated';
import { OrgWithOAuthAppsTargetResponse } from './orgWithOAuthAppsTargetResponse';
import { VcdsDeploymentStateEnum } from './vcdsDeploymentStateEnum';
import { VcdsDeploymentCommerce } from './vcdsDeploymentCommerce';
import { VcdsDeploymentStats } from './vcdsDeploymentStats';
import { OperatorVcdsDeploymentNetwork } from './operatorVcdsDeploymentNetwork';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { OperatorVcdsDeploymentApplicationAndInfraHealth } from './operatorVcdsDeploymentApplicationAndInfraHealth';
import { OperatorVcdsDeploymentCloudProvider } from './operatorVcdsDeploymentCloudProvider';
import { VcdsDeploymentSystemIssue } from './vcdsDeploymentSystemIssue';
import { MonitorMinResponse } from './monitorMinResponse';
import { DeploymentTargetResponse } from './deploymentTargetResponse';
import { IrrCertMinResponse } from './irrCertMinResponse';
import { VcdsDeploymentInventoryTree } from './vcdsDeploymentInventoryTree';
import { VcdsDeploymentVersion } from './vcdsDeploymentVersion';


/**
 * @type RolloutTargetEntityDetails
 * @export
 */
export type RolloutTargetEntityDetails = DeploymentTargetResponse | OrgWithOAuthAppsTargetResponse;

